import { useAuthToken } from '@/hooks/useAuthToken';
import { useAuth } from '@/pages/AuthContext';

// gloss
// why: a logged-in user must never be re-prompted for OTP/login — if either of the two auth
// why: checks passes, treat as authenticated.
export const useIsUserAuthenticated = (): boolean => {
  const { isAuthenticated: hasValidToken } = useAuthToken();
  const { authCredentialsAvailable } = useAuth();

  return hasValidToken || authCredentialsAvailable();
};
